import React from 'react';
import get from 'lodash/get';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { RegisterOptions } from 'react-hook-form';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface ISsoUniqueIdentifierInputProps {
  name: string;
  id: string;
  label: string;
  rules?: RegisterOptions;
}

export const SsoUniqueIdentifierInput: React.FC<ISsoUniqueIdentifierInputProps> =
  ({ name, id, label, rules }) => {
    const { errors, control } = useFormContext();

    return (
      <CookbookInputWrapper
        name={name}
        id={id}
        control={control}
        error={get(errors, name)}
        aria-label={name}
        inputSize="medium"
        blockWidth
        label={`${label} *`}
        placeholder="e.g. jg302932"
        rules={{
          required: `${label} is required`,
          ...rules,
        }}
      />
    );
  };
